// extracted by mini-css-extract-plugin
module.exports = {"Base":"Base--6aiuU","Settings":"Settings--yMy5B","Dashboard":"Dashboard--1IGUA","Auth":"Auth--25Elv","Group":"Group--1m42T","DashboardGroup":"DashboardGroup--1ufGL"};